module.exports = __webpack_public_path__ + "static/media/LoginBackground.4330da12.jpg";